import { Globe, Zap, Shield, GitBranch, Lock, BarChart3, Layers, RefreshCw } from "lucide-react";

const features = [
  { icon: Globe, title: "Global edge network", text: "300+ locations worldwide. Your code runs where your users are." },
  { icon: Zap, title: "Sub-second deploys", text: "Push to main and you're live. No pipelines, no waiting." },
  { icon: Shield, title: "Enterprise security", text: "SOC 2 compliant. DDoS protection on every plan." },
  { icon: GitBranch, title: "Git-native workflow", text: "Push to deploy. Preview every branch. Rollback in one click." },
  { icon: Lock, title: "Automatic SSL", text: "Every deployment gets HTTPS. Zero configuration." },
  { icon: BarChart3, title: "Real-time analytics", text: "Monitor performance, traffic, and errors live." },
  { icon: Layers, title: "Auto scaling", text: "From zero to millions. Scales up and down automatically." },
  { icon: RefreshCw, title: "Instant rollbacks", text: "Something break? Roll back to any previous deploy in one click." },
];

const FeaturesSection = () => {
  return (
    <section id="features" className="bg-[#f8f9fa] py-16 sm:py-20 lg:py-24" data-testid="features-section">
      <div className="max-w-[1440px] mx-auto px-6 lg:px-8">
        {/* Header */}
        <div className="max-w-2xl mb-12">
          <h2 className="text-[28px] sm:text-[34px] lg:text-[40px] font-normal text-[#202124] leading-tight">
            Everything you need to{" "}
            <span className="text-[#ff9a4d]">ship fast</span>
          </h2>
          <p className="mt-4 text-[15px] sm:text-base text-[#5f6368] leading-relaxed">
            All the tools and infrastructure to go from idea to production — included in every plan.
          </p>
        </div>

        {/* Feature grid */}
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5 lg:gap-6" data-testid="features-grid">
          {features.map((feat, i) => {
            const Icon = feat.icon;
            return (
              <div
                key={feat.title}
                className="bg-white p-6 rounded-xl border border-[#e8eaed] hover:border-[#dadce0] hover:shadow-sm transition-all"
                data-testid={`feature-card-${i}`}
              >
                <div className="w-10 h-10 rounded-lg bg-[#fff4eb] flex items-center justify-center mb-4">
                  <Icon className="w-5 h-5 text-[#ff9a4d]" />
                </div>
                <h3 className="text-[15px] font-medium text-[#202124] mb-1.5">{feat.title}</h3>
                <p className="text-[13px] text-[#5f6368] leading-relaxed">{feat.text}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
